import { Accordion, useDeviceType } from '@cian/ui-kit';
import type { TFaqItem } from 'shared/types/faq';
import * as styles from './styles.css';
import { Block } from './components/Block';
import clsx from 'clsx';

interface IFaqProps {
  items: TFaqItem[];
}

export const Faq: React.FC<IFaqProps> = ({ items }) => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const accordionSize = isPhone ? 'S' : 'M';

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>{isPhone ? 'Вопросы' : 'Ответы на вопросы'}</div>
      <Accordion
        size={accordionSize}
        items={items.map((item, index) => ({
          title: item.title,
          content: item.content.map((contentArray, contentIndex) => (
            <Block key={contentIndex} content={contentArray} />
          )),
          key: index,
        }))}
      />
    </div>
  );
};
